import React, { useEffect, createElement } from 'react';
import { FlameCanvas } from './components/FlameCanvas';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TransformationSection } from './components/TransformationSection';
import { ProductSection } from './components/ProductSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { RitualIndexSection } from './components/RitualIndexSection';
import { BonusSection } from './components/BonusSection';
import { ForWhomSection } from './components/ForWhomSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { useScrollFadeIn } from './hooks/useScrollFadeIn';
const PIXEL_ID = '759566727183941';
export function App() {
  useScrollFadeIn();
  useEffect(() => {
    // Inject Meta Pixel script
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen relative" data-id="element-0">
      <FlameCanvas data-id="element-1" />
      <div className="page-bg" data-id="element-2"></div>

      <AnnouncementBar data-id="element-3" />
      <Hero data-id="element-4" />
      <PainSection data-id="element-5" />
      <TransformationSection data-id="element-6" />
      <ProductSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <RitualIndexSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <ForWhomSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <GuaranteeSection data-id="element-14" />
      <FAQSection data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
      <RecentPurchaseToast data-id="element-18" />
      <ExitIntentPopup data-id="element-19" />
    </div>;
}